var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z","key":1})]);
}

Trash.defaultProps = {"height":"24px","viewBox":"0 0 24 24","width":"24px"};

module.exports = Trash;

Trash.default = Trash;
